import React, { memo } from "react";
import classes from "./StandardTable.scss";
import _ from "lodash";
import StandardsView from "../StandardsView";
import StandardFilter from "../StandardFilter";
import { DEFAULT_STANDARD_FILTERS } from "../../Utils";
import {
  getIsStandardsRevampEnabled,
  DEFAULT_HIDDEN_COLUMNS,
  getIsStandardsV2,
} from "Post/utils";
import { connect } from "react-redux";

import { getAcademicSetupType } from "Teacher/routes/LearningCourses/modules/Utils";
import { DATA_SET_COLUMNS_SETTING } from "Constants/permissionConstants";
import { COURSE_BASED_GRADING } from "Constants/stringConstants";
import { DATA_GRID_COLUMN_TYPES } from "StandardsTable/modules/constants";

import {
  DATA_GRID_COLUMNS,
  NON_CONFIGURABLE_COLUMNS,
  STANDARD_COLUMNS,
} from "AppComponents/StandardsSelectionModal/modules/Constants";

import ConfigureColumns from "AppComponents/StandardsSelectionModal/components/ConfigureColumns/ConfigureColumns";
import { DSProvider } from "@toddle-edu/ds-web";
import {
  useStandardsTableProps,
  useStandardsConfigureColumns,
} from "StandardsTable/hooks";
import ConditionalWrapper from "Utils/ConditionalWrapper";

const StandardTable = props => {
  const {
    updatePost,
    subjects,
    grades,
    tags,
    setStandardFilters,
    standardFilters,
    selectedStandards,
    setSelectedStandards,
    edges,
    selectedStandardSetId,
    columns,
    selectedSubject,
    learningCourseId,
  } = props;

  const {
    columnIdsForConfigureModal,
    currentColumns,
    updateColumns,
  } = useStandardsConfigureColumns({
    settingName: DATA_SET_COLUMNS_SETTING,
    moduleName: "PortfolioStandards",
    defaultColumns: columns,
    nonConfigurableColumns: NON_CONFIGURABLE_COLUMNS,
    defaultHiddenColumns: DEFAULT_HIDDEN_COLUMNS,
  });

  const isStandardsUIRevamped =
    getIsStandardsV2() && _.isUndefined(learningCourseId);
  const customResetFilters = () => {
    _.isFunction(updatePost) &&
      updatePost({ standardFilters: DEFAULT_STANDARD_FILTERS });
    _.isFunction(setStandardFilters) &&
      setStandardFilters(DEFAULT_STANDARD_FILTERS);
    _.isFunction(setSelectedStandards) &&
      setSelectedStandards(selectedStandards);
  };

  const { properties } = useStandardsTableProps({
    columns: STANDARD_COLUMNS,
  });
  return (
    <DSProvider dsVersion="2.0">
      {learningCourseId ? (
        <div className={classes.standardFilterContainer}>
          <StandardFilter
            subjects={subjects}
            grades={grades}
            tags={tags}
            updatePost={updatePost}
            setStandardFilters={setStandardFilters}
            standardFilters={
              _.isEmpty(standardFilters)
                ? DEFAULT_STANDARD_FILTERS
                : standardFilters
            } // Ensure default filters are used if empty
          />
          {getIsStandardsRevampEnabled() && learningCourseId ? (
            <ConfigureColumns
              currentColumns={currentColumns}
              updateColumns={updateColumns}
              columnIdsForConfigureModal={columnIdsForConfigureModal}
              properties={properties}
            />
          ) : null}
        </div>
      ) : null}
      <ConditionalWrapper
        type={"wrapperAsElement"}
        condition={isStandardsUIRevamped}
        wrapper={<div className={classes.dataGridWapper} />}
      >
        <StandardsView
          selectedStandardSetId={selectedStandardSetId}
          selectedStandards={selectedStandards}
          setSelectedStandards={setSelectedStandards}
          edges={edges}
          customResetFilters={customResetFilters}
          selectedSubject={selectedSubject}
          learningCourseId={learningCourseId}
          currentColumns={currentColumns}
        />
      </ConditionalWrapper>
    </DSProvider>
  );
};

const mapStateToProps = state => {
  const academicSetupType = getAcademicSetupType();
  const isCourseBasedGrading = academicSetupType === COURSE_BASED_GRADING;

  const columns = isCourseBasedGrading
    ? DATA_GRID_COLUMNS
    : _.without(DATA_GRID_COLUMNS, DATA_GRID_COLUMN_TYPES.SUBJECT_AREAS);

  return {
    columns,
  };
};
export default connect(mapStateToProps, null)(memo(StandardTable));
